import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

export const useUnconfirmProductsMutation = (onSettled: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: unconfirmProductsMutation } = useMutation({
		mutationFn: (ids: number[]) => {
			return axiosPrivate.post(apiRoutes.productsUnconfirm, { ids })
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
			useToast({
				type: 'success',
				message: t('Products unconfirmed')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		unconfirmProductsMutation
	}
}
